//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BaselineFile",1,0],[0,"BaselineLocation",1,0],[0,"BaselineNumber",1,0],[0,"BaselineRevision",1,0],[0,"CloneAssembly",1,0],[0,"FileFormat",1,0],[0,"FileNote",1,0],[0,"FileUnits",1,0],[1,"SelectedObjects",0,"SelectNXObjectList",0],[0,"ShowLog",1,0],[0,"TagModel",1,0],[0,"UseCloneSelection",1,0],[0,"UseCurrentWorkPart",1,0]],[[[],"RunPreExportBaselineHook",{},0,0]],[]];
SPLM.PcbExchange.IdxExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.IdxExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.IdxExportBuilder.FileFormatEnum = Object.freeze({
    "Idx2" : "Idx2", "Idx3" : "Idx3"});

SPLM.PcbExchange.IdxExportBuilder.IdxLocationEnum = Object.freeze({
    "Os" : "Os", "TeamcenterDS" : "TeamcenterDS", "TeamcenterCS" : "TeamcenterCS"});

SPLM.PcbExchange.IdxExportBuilder.ExportUnitsEnum = Object.freeze({
    "Mm" : "Mm", "Thou" : "Thou"});

export default SPLM;